import { StoreApi, UseBoundStore } from 'zustand';

export const createSelectors = <S extends UseBoundStore<StoreApi<object>>>(_store: S) => {
    const store = _store as WithSelectors<typeof _store>;
    store.use = {};
    Object.keys(store.getState()).forEach((key) => {
        (store.use as any)[key] = () => store((s) => s[key as keyof typeof s]);
    });

    return store;
};
